export function mapKeys(arg1, arg2) {
    if (arguments.length === 1) {
        return function (data) { return _mapKeys(data, arg1); };
    }
    return _mapKeys(arg1, arg2);
}
function _mapKeys(obj, fn) {
    return Object.keys(obj).reduce(function (acc, key) {
        acc[fn(key, obj[key])] = obj[key];
        return acc;
    }, {});
}
